import Vue from 'vue' // VUE
import App from './App.vue' // 项目入口
import router from './router' // 路由
import store from './store' // vue 状态库
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './icons'
import './router/filter/index'
import HighchartsVue from 'highcharts-vue' // highcharts 组件库
import { getSystemSelection } from './api/global/globalApi' // 全局下拉框接口
import { checkBtnPermission, formatDate, notify, formatDateYMD } from './utils/util.js' // 全局工具类
import BaiduMap from 'vue-baidu-map'
import * as filters from './filters' // 全局过滤方法
import _ from 'lodash'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// vue-echarts
import vueEcharts from 'vue-echarts'
Vue.component('v-chart',vueEcharts)


// import 'lib-flexible'

Vue.prototype.$getSystemSelection = getSystemSelection
Vue.prototype.checkBtnPermission = checkBtnPermission
Vue.prototype.formatDate = formatDate
Vue.prototype.$formatDateYMD = formatDateYMD
Vue.prototype.Notify = notify
Vue.prototype._ = _
Vue.use(ElementUI)
Vue.use(router)
Vue.use(ViewUI)
Vue.use(HighchartsVue)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

// 全局过滤方法 注册
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(BaiduMap, {
  ak: 'RhsfMFNqG4hyA48vTHMHezR5dfnFDfgd'
})

// runtime（运行模式）
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
